import React from 'react';

export const Report = (props) => (
  <svg
    fill="none"
    height="24"
    id="reportsIcon"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      height="10.5"
      rx="0.75"
      stroke="white"
      strokeWidth="1.5"
      width="4.5"
      x="0.75"
      y="12.75"
    />
    <rect
      height="16.5"
      rx="0.75"
      stroke="white"
      strokeWidth="1.5"
      width="4.5"
      x="9.75"
      y="6.75"
    />
    <rect
      height="22.5"
      rx="0.75"
      stroke="white"
      strokeWidth="1.5"
      width="4.5"
      x="18.75"
      y="0.75"
    />
  </svg>
);
